module.exports = __webpack_public_path__ + "media/src/images/icons/magnifying_glass_xxl-136969a92f9ae12807dd832d454b3339.svg";